import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const CoverageMeter = ({
  label,
  value,
  color,
  sublabel,
}: {
  label: string;
  value: number;
  color: string;
  sublabel?: string;
}) => {
  const clampedValue = Math.max(0, Math.min(100, value));

  return (
    <div css={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(0.5) }}>
      <Text size='small' color='light'>
        {label}
      </Text>
      <div css={meterRowStyles}>
        <Text weight='bold' size='large' css={{ color, flexShrink: 0 }}>
          {value}%
        </Text>
        <div
          css={meterTrackStyles}
          role='progressbar'
          aria-label={label}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={clampedValue}
          aria-valuetext={`${clampedValue}%`}
        >
          <div css={meterFillStyles(clampedValue, color)} />
        </div>
      </div>
      {sublabel && (
        <Text size='small' color='light'>
          {sublabel}
        </Text>
      )}
    </div>
  );
};

const meterTrackStyles = css({
  backgroundColor: theme.colors.neutral10,
  borderRadius: theme.borderRadius.full,
  height: 8,
  flex: 1,
  overflow: 'hidden',
});

const meterRowStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
});

const meterFillStyles = (value: number, color: string) =>
  css({
    width: `${value}%`,
    backgroundColor: color,
    height: '100%',
  });
